import { render, staticRenderFns } from "./UploadVideo.vue?vue&type=template&id=76a9c741&scoped=true&"
import script from "./UploadVideo.vue?vue&type=script&lang=js&"
export * from "./UploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo.vue?vue&type=style&index=0&id=76a9c741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9c741",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a9c741')) {
      api.createRecord('76a9c741', component.options)
    } else {
      api.reload('76a9c741', component.options)
    }
    module.hot.accept("./UploadVideo.vue?vue&type=template&id=76a9c741&scoped=true&", function () {
      api.rerender('76a9c741', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/mix/UploadVideo.vue"
export default component.exports